<template>
  <!-- MODAL OFFRIR -->
  <div :class="{ 'OfferModal': true, 'OfferModal--small': $mq === 'mobile'}">
    <div class="TopRightClose">
      <button @click="close">
        x
      </button>
    </div>
    <div class="OfferModalContainer display-column">
      <div class="OfferModalInformations display-column">
        <span class="OfferModalTitle">Vous souhaitez offrir la MasterClass</span>
        <span class="OfferModalTitle2">{{ masterclass.title }}</span>
        <span class="OfferModalSubtitle">La personne recevra son cadeau par mail. <br />Merci de renseigner les informations ci-dessous</span>
      </div>
      <div class="OfferModalForm">
        <div class="Email">
          <vv-form-text-input
            label="lastname"
            id="lastname"
            v-model="lastnameGift"
            :validate="'required'"
          />
          <vv-form-text-input
            label="firstname"
            id="firstname"
            v-model="firstnameGift"
            :validate="'required'"
          />
          <vv-form-text-input
            label="username"
            id="email"
            v-model="emailGift"
            :validate="'required|email'"
          />
        </div>
        <div class="Buttons">
          <button type="button" @click="close">Annuler</button>
          <button type="submit" @click="validate">Valider le cadeau</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VvFormTextInput from '@/components/common/forms/vinovibes/VvFormTextInput'


export default {
  name: 'ModalGift',
  components: {
    VvFormTextInput
  },
  props: {
    masterclass: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      emailGift: null,
      lastnameGift: null,
      firstnameGift: null
    }
  },
  computed: {

  },
  methods: {
    validate() {
      this.$emit('propagate-validate-gift', {
        emailGift: this.emailGift, 
        lastnameGift: this.lastnameGift, 
        firstnameGift: this.firstnameGift,
        variantId: 'id' in this.masterclass ? this.masterclass.id : null
      });
    },
    close() {
      this.$emit('propagate-close-modal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';


.OfferModal {

  .TopRightClose {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 10px;
    @media screen and (max-width: 450px) {
      margin: 5px;
    }

    button {
      border: none;
      outline: none;
      background: none;
    
      &:hover {
        cursor: pointer;
      }
    }
  }

  .OfferModalContainer {
    display: flex;
    margin-left: 20px;
    margin-right: 20px;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: center;
    align-items: center;
    // height: 300px;

    .OfferModalInformations {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-bottom: 40px;

      .OfferModalTitle {
        font-size: 35px;
        font-weight: bold;
        font-family: Helvetica, sans-serif;
      }

      .OfferModalTitle2 {
        font-size: 35px;
        font-family: Caveat;
        color: $primary;
        margin-bottom: 5px;
      }

      .OfferModalSubtitle {
        font-size: 20px;
        font-weight: 500;
        font-family: Helvetica, sans-serif;
      }
    }

    .OfferModalForm {
      display: flex;
      flex-direction: row !important;
      align-content: center;
      justify-content: space-around;
      flex-wrap: wrap;
      align-items: center;
      margin-left: 30px;
      margin-right: 30px;
      height: 250px;
      width: 80%;
      @media screen and (max-width: 450px) {
        margin-left: 15px;
        margin-right: 15px;
      }

      .Email, .Buttons {
        width: 100%;
      }

      .Buttons {
        display: flex;
        justify-content: space-around;

        button {
          margin-bottom: 14px;
          // min-width: 200px;
          height: 40px;
          border-radius: 30px;
          background-color: $primary;
          color: $font-button;
          box-shadow: unset;
          border: unset;
          font-weight: bold;
          font-size: 20px;
          padding: 10px 20px 10px 20px;

          // @include for-size(phone-only) {
          //   min-width: 100px;
          // }

          &:hover {
            cursor: pointer;
          }
        }
      }

    }
  }
  &--small {

    .OfferModalForm {
      margin-top: 30px !important;
      margin-left: 0px !important;
      margin-right: 0px !important;
      width: 100% !important;
    }

    .OfferModalTitle, .OfferModalTitle2 {
      font-size: 25px !important;
    }

    .OfferModalSubtitle {
      font-size: 15px !important;
    }

    .Buttons {
      flex-direction: column !important;
    }
  }
}


</style>
